module.exports = __webpack_public_path__ + "img/4_5.6f4f9de1.png";